// «Quitar» con confirmación en el mismo lugar (sin ventana aparte). Una sección entera no tiene «deshacer»: un clic
// mal dado la borra. El botón de siempre abre la pregunta; recién «Sí, quitar» borra. Es la misma forma que ya tenía
// «Quitar bloque».
import { useState } from 'react';
import { EstilosDelEditor } from './EstilosDelEditor';

export function QuitarConConfirmacion({
  etiqueta = 'Quitar',
  ariaLabel,
  pregunta,
  onConfirmar,
  estilo,
}: {
  /** El texto del botón: «Quitar», «Quitar bloque»… */
  etiqueta?: string;
  ariaLabel: string;
  /** «¿Quitar esta sección?» */
  pregunta: string;
  onConfirmar: () => void;
  estilo?: React.CSSProperties;
}) {
  const [preguntando, setPreguntando] = useState(false);
  if (!preguntando) {
    return (
      <>
        <EstilosDelEditor />
        <button
          type="button"
          className="dd-btn dd-btn-chico dd-btn-peligro"
          style={estilo}
          aria-label={ariaLabel}
          onClick={() => setPreguntando(true)}
        >
          {etiqueta}
        </button>
      </>
    );
  }
  return (
    <span
      role="alertdialog"
      aria-label={`Confirmar: ${ariaLabel}`}
      style={{
        fontSize: 13,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        flexWrap: 'wrap',
      }}
    >
      {pregunta}
      <button
        type="button"
        className="dd-btn dd-btn-chico dd-btn-peligro"
        onClick={() => {
          setPreguntando(false);
          onConfirmar();
        }}
      >
        Sí, quitar
      </button>
      <button type="button" className="dd-btn dd-btn-chico" onClick={() => setPreguntando(false)}>
        No
      </button>
    </span>
  );
}
